import { useState } from 'react';
import { IItinerary } from 'common/types';
import { SearchType } from 'contexts/searchParams';
import { IOta } from 'detail/types';
import { Validation, validateAgreeStatus } from 'detail/utils';
import { stringifyRoutes } from 'list/domestic/utils';

export default function useAgreement(
  adult: number,
  child: number,
  infant: number,
  fareType: string,
  schedules: IItinerary[],
  searchType: SearchType,
  stayLength?: string,
) {
  const [isModalOn, setIsModalOn] = useState(false);
  const [isRequired, setIsRequired] = useState(false);
  const [ota, setOta] = useState<IOta>();

  const closeModal = () => setIsModalOn(false);

  const getRedirectUrl = (bookingUrl: string, fare: number, otaId: string) =>
    `/redirect/${searchType}/${stringifyRoutes(
      schedules,
    )}?${new URLSearchParams({
      adult: `${adult}`,
      child: `${child}`,
      infant: `${infant}`,
      fare: `${fare}`,
      fareType,
      otaId,
      ...(stayLength && { stayLength }),
      redirectUrl: bookingUrl,
    }).toString()}`;

  const handleBooking = (selected: IOta) => () => {
    const [validation, isAgreementRequired] = validateAgreeStatus(
      selected.otaId,
      selected.agreeStatus,
    );
    switch (validation) {
      case Validation.LOGIN_REQUIRED: {
        window.location.href = `https://nid.naver.com/nidlogin.login?svctype=262144&url=${encodeURIComponent(
          window.location.href,
        )}`;
        break;
      }
      case Validation.AGREEMENT_REQUEST: {
        setOta(selected);
        setIsRequired(isAgreementRequired);
        setIsModalOn(true);
        break;
      }
      case Validation.BOOKING_AVAILABLE: {
        window.open(
          getRedirectUrl(selected.bookingUrl, selected.fare, selected.otaId),
        );
        break;
      }
      default:
    }
  };

  return {
    isAgreementRequired: isRequired,
    isModalOn,
    ota,
    closeModal,
    getRedirectUrl,
    handleBooking,
  };
}
